module.exports = __webpack_public_path__ + "static/media/register.9900dbd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/register.jpg
// module id = 368
// module chunks = 33